import React, { useReducer } from 'react';
import { DocumentsModalScrollInfo } from 'components/newAccountSteps/initialStep/documentation/documentsModal/DocumentsModalScrollInfo';
import { doTagReadDocumentInfoModal } from 'components/newAccountSteps/initialStep/documentation/tagging';

export const useScrollInfoModal = ({ onClickCancelButton }) => {
    const initialState = {
        scrollInfoModalShow: false,
        scrollInfoModalShowed: false,
    };
    const [{ scrollInfoModalShow, scrollInfoModalShowed }, dispatch] = useReducer((prev, next) => {
        return { ...prev, ...next };
    }, initialState);

    const handleClickCancelButtonModalScrollInfo = e => {
        e.preventDefault();
        dispatch({ scrollInfoModalShow: false });
        onClickCancelButton(e);
        doTagReadDocumentInfoModal({ tag: 'exit', action: 'exit', format: 'modal', element: 'exit' });
    };
    const handleClickContinueButtonModalScrollInfo = e => {
        e.preventDefault();
        dispatch({ scrollInfoModalShow: false });
        doTagReadDocumentInfoModal({
            tag: 'understood',
            action: 'click',
            format: 'button',
            element: 'understood',
        });
    };
    const handleClickCloseButtonModalScrollInfo = e => {
        e.preventDefault();
        dispatch({ scrollInfoModalShow: false });
        doTagReadDocumentInfoModal({ tag: 'close', action: 'close', format: 'cross', element: 'cross' });
    };
    const openScrollInfoModal = () => {
        doTagReadDocumentInfoModal({ tag: 'open', action: 'open', format: 'modal', element: 'full' });
        dispatch({ scrollInfoModalShowed: true, scrollInfoModalShow: true });
    };

    const renderScrollInfoModal = () => {
        if (!scrollInfoModalShow) return null;

        return (
            <DocumentsModalScrollInfo
                handleClickCloseButton={handleClickCloseButtonModalScrollInfo}
                handleClickCancelButton={handleClickCancelButtonModalScrollInfo}
                handleClickContinueButton={handleClickContinueButtonModalScrollInfo}
            />
        );
    };

    return { scrollInfoModalShow, scrollInfoModalShowed, renderScrollInfoModal, openScrollInfoModal };
};
